import { TableTranslations } from '@/assets/locales/components/table/table.translations.en';

export const tableTranslations: TableTranslations = {
  content: {
    button: {
      resetForm: 'Resetuj',
      submitSearch: 'Szukaj',
    },
    maxRows: 'Maksymalna liczba wierszy',
    nextPage: 'Następna strona',
    noResults: 'Brak wyników',
    of: 'z',
    previousPage: 'Poprzednia strona',
  },
};
